import axios from 'axios';
import { GET_TOP_PRODUCTS, TOP_PRODUCTS_LOADING } from './types';

export const getTopProducts = () => (dispatch: any) => {
  dispatch({ type: TOP_PRODUCTS_LOADING });
  axios
    .get('/api/admin/getTopProducts')
    .then((res) => dispatch({ type: GET_TOP_PRODUCTS, payload: res.data }))
    .catch((err) => console.log(err));
};
